"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Red = exports.Orange = exports.Green = exports.Blue = exports.Black = void 0;
// To keep the brand colors aligned it's important that all colors are taken from those color scheme
// if color is missing it may be added to the palette below (with 50 point gap between colors ideally)
// Note that if new color is close enough to an existing and used color consider using it
//  (the design received has slight color diffs on same controls between pages for no good reason,
//      error that should be ignored)

var Blue = exports.Blue = {
  10: '#F8FAFB',
  20: '#F7FCFE',
  50: '#ECF9FE',
  90: '#D6EEF5',
  100: '#D8EAF1',
  150: '#F7FCFE',
  170: '#B8D1DE',
  180: '#00A9E926',
  190: '#8db6c8',
  195: '#4ccfff',
  200: '#00A9E9',
  300: '#236A92',
  500: '#123F56',
  550: '#082a39'
};
var Orange = exports.Orange = {
  30: '#FCEFE2',
  50: '#FBE4CF',
  100: '#FADCBF',
  120: '#FFF7EF',
  290: '#ffc528',
  300: '#FDB912',
  310: '#F6B325',
  440: '#FF9300',
  450: '#f39131',
  500: '#ED8D0B'
};
var Red = exports.Red = {
  50: '#FFF9F8',
  200: '#FAA9A3',
  500: '#FF1827'
};
var Black = exports.Black = {
  1: '#00000019',
  10: '#FDFDFD',
  20: '#FAFAFA',
  30: '#F8F8F8',
  85: '#EFEFEF',
  90: '#EEEEEE',
  100: '#e8e8e8',
  150: '#D3D3D3',
  170: '#AAAAAA',
  220: '#939393',
  280: '#747474',
  290: '#686868',
  300: '#606060',
  500: '#3A3A3A',
  900: '#424242'
};
var Green = exports.Green = {
  1: '#228b22',
  2: '#80CE16'
};